
import { useStore } from "../../state/state.ts";
import Measure from "../measure.tsx";
import ModalPhotovoltaik from "../../modals/modal_photovoltaik.tsx";
import ModalPhotovoltaikFuture from "../../modals/modal_photovoltaik_future.tsx";
import { MASSNAHMEN_PHOTOVOLTAIK_OPTIONS_CURRENT_LABELS, MASSNAHMEN_PHOTOVOLTAIK_OPTIONS_NEW_LABELS } from "../../state/types.ts";

export default function MeasureWidgetPhotovoltaik() {
  // @ts-ignore:TS6133
  //const _properties = useStore((state)=>state.properties); //MUST EXIST FOR REACTIVITY TO WORK
  const photovoltaik = useStore((state)=>state.photovoltaik || "");
  const photovoltaik_future = useStore((state)=>state.photovoltaik_future || "");

  const push_modal = useStore((state) => state.push_modal_closeable);
  const is_step_id = useStore((state) => state.is_step_id);
  const measure_lables = useStore((state)=>state.measure_lables);

  if (photovoltaik == "" && photovoltaik_future == ""){
    return <></>;
  }

          const current = measure_lables[photovoltaik] || MASSNAHMEN_PHOTOVOLTAIK_OPTIONS_CURRENT_LABELS[photovoltaik] || "" ;
          const future = measure_lables[photovoltaik_future] || MASSNAHMEN_PHOTOVOLTAIK_OPTIONS_NEW_LABELS[photovoltaik_future] || "" ;
  return <Measure key={"measure-widget-photovoltaik"} label={"Photovoltaik"} now={current} future={future} onClick={() => push_modal(is_step_id("future")?<ModalPhotovoltaikFuture/>:<ModalPhotovoltaik/>)}/>;
}
